(function ($) {
        $.fn.filesUpload = function () {
            return this.each(function () {
                    const POST_MAX_SIZE = 2560000;
                    const MAX_WIDTH = 1280;
                    const MAX_HEIGHT = 1280;
                    const MIME_TYPE = "image/jpeg";
                    let QUALITY = 1;

                    let myFilesUpload = $(this);
                    let $form = null;
                    let $formInput = null;

                    let $inputHidden = myFilesUpload.find('input:hidden').first();
                    let $progress = myFilesUpload.find('.progress-upload');
                    let $progressBar = myFilesUpload.find('.progress-bar-upload');
                    let $fileLabel = myFilesUpload.find('.custom-file-label');
                    let $inputFile = myFilesUpload.find('input:file');
                    $inputHidden.val('');
                    $inputFile.val('');
                    $fileLabel.html();

                    let $percentCompleted = 0;

                    const axios = require('axios');
                    const sendGetForm = async () => {
                        try {
                            const resp = await axios.get(myFilesUpload.data('view'));
                                    $form = $(resp.data).appendTo($('body')).css('display', 'none');
                                    $formInput = $form.find('input:file');
                                    $inputFile
                                        .on('click', function (e) {
                                            $formInput.click();
                                            e.stopPropagation();
                                            e.preventDefault();
                                        });
                                    $progressBar
                                        .bind('reset', function () {
                                            $percentCompleted = 0;
                                            fillProgressBar($percentCompleted);
                                        })
                                        .trigger('reset');

                                $formInput.on('change', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    myFilesUpload.parents('form:first').trigger('filesUploadBefore');
                                    myFilesUpload.addClass('files-upload-en-cours');
                                    const files = this.files;
                                    for (let i = 0; i < files.length; i++) {
                                        let file = files[i];
                                        const ArrayOfMime = ["gif", "png", "jpg", "jpeg", "pdf"];
                                        const ArrayOfImage = ["gif", "png", "jpg", "jpeg"];
                                        let typeMime = file.type.split('/').pop();
                                        if (file.size > POST_MAX_SIZE) QUALITY = 0.8;
                                        if (ArrayOfMime.includes(typeMime)) {
                                            if (ArrayOfImage.includes(typeMime)) {
                                                const blobURL = URL.createObjectURL(file);
                                                const img = new Image();
                                                img.src = blobURL;
                                                img.onerror = function () {
                                                    URL.revokeObjectURL(this.src);
                                                    addAlertBox('alert-danger', "Le fichier ne peux pas être chargé, merci de choisir un autre fichier.");
                                                    return;
                                                };
                                                img.onload = function () {
                                                    URL.revokeObjectURL(this.src);
                                                    const [newWidth, newHeight] = calculateSize(img, MAX_WIDTH, MAX_HEIGHT);
                                                    const canvas = document.createElement("canvas");
                                                    canvas.width = newWidth;
                                                    canvas.height = newHeight;
                                                    const ctx = canvas.getContext("2d");
                                                    ctx.drawImage(img, 0, 0, newWidth, newHeight);
                                                    canvas.toBlob((blob) => {
                                                        const blobSize = blob.size;
                                                        const formData = new FormData();
                                                        formData.append('file', blob);
                                                        formData.append('multiple', "1");
                                                        formData.append('type', "image");
                                                        formData.append('_token', $('input[name=_token]').val());
                                                        sendFileToProgressBar(myFilesUpload.data('blob'), formData, file.name);
                                                    }, MIME_TYPE, QUALITY);
                                                };
                                            } else {
                                                const formData = new FormData();
                                                formData.append('file', file);
                                                formData.append('multiple', "1");
                                                formData.append('type', "pdf");
                                                formData.append('_token', $('input[name=_token]').val());
                                                sendFileToProgressBar(myFilesUpload.data('view'), formData, file.name);
                                            }
                                        } else {
                                            $fileLabel.html();
                                            $inputHidden.val("");
                                            let result = '<span>Les erreurs suivantes ont été trouvées: </span><ul class="list-group errorUl">';
                                            result += '<li class="list-group-item list-group-item-danger">Le type de fichier utilisé n\'est pas autorisé.</li>';
                                            result += '</ul>';
                                            addAlertBox('alert-danger', result);
                                            return;
                                        }
                                        checkSizeMax(this.form, ArrayOfMime, typeMime, POST_MAX_SIZE);
                                    }
                                })
                        } catch (err) {
                            addAlertBox('alert-danger', 'Impossible de charger le formulaire');
                        }
                    };
                sendGetForm();

                function FileConvertSize(aSize) {
                    aSize = Math.abs(parseInt(aSize, 10));
                    let def = [[1, 'octets'], [1024, 'ko'], [1024 * 1024, 'Mo'], [1024 * 1024 * 1024, 'Go'], [1024 * 1024 * 1024 * 1024, 'To']];
                    for (let i = 0; i < def.length; i++) {
                        if (aSize < def[i][0]) return (aSize / def[i - 1][0]).toFixed(2) + ' ' + def[i - 1][1];
                    }
                }

                function checkSizeMax(form, ArrayOfMime, typeMime, POST_MAX_SIZE) {
                    const size = getAllFileSize(form);
                    if (size > POST_MAX_SIZE) {
                        if (ArrayOfMime.includes(typeMime)) {
                            addAlertBox('alert-warning', 'Fichier(s) trop volumineux (max: ' + FileConvertSize(POST_MAX_SIZE) + ') - Compression du fichier en cours...');
                            return;
                        } else {
                            addAlertBox('alert-danger', 'Fichier(s) trop volumineux (max: ' + FileConvertSize(POST_MAX_SIZE) + ')');
                            return;
                        }
                    }
                }

                function sendFileToProgressBar(urlUpload, formData, name) {
                    $progressBar.bind('reset', function () {
                        $percentCompleted = 0;
                        fillProgressBar($percentCompleted);
                    }).trigger('reset');

                    const config = {
                        onUploadProgress: function (progressEvent) {
                            $percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            fillProgressBar($percentCompleted);
                        }, headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    axios.post(urlUpload, formData, config)
                        .then(response => {
                            $inputHidden.val(JSON.stringify(response.data));
                            $fileLabel.html(name);
                            addAlertBox('alert-success', 'Fichier(s) uploadé(s) avec succès');
                            $progressBar.trigger('reset');
                            myFilesUpload.removeClass('files-upload-en-cours');
                            myFilesUpload.parents('form:first').trigger('filesUploadAfter');
                        })
                        .catch(function (error) {
                            if (error.response) {
                                const code = error.response.status
                                const response = error.response.data
                                let result = '<span>Les erreurs suivantes ont été trouvées: </span><ul class="list-group errorUl">';
                                //Fichier trop lourd
                                if (code === 413) {
                                    result += '<li class="list-group-item list-group-item-danger">Le poids du fichier est trop gros</li>';
                                } else {
                                    $.each(response.file, function (key, value) {
                                        result += '<li class="list-group-item list-group-item-danger">' + value + '</li>';
                                    })
                                }
                                result += '</ul>';
                                addAlertBox('alert-danger', result);
                                $(document).find('.progress-bar-upload').trigger('reset');
                                myFilesUpload.removeClass('files-upload-en-cours');
                                myFilesUpload.parents('form:first').trigger('filesUploadAfter');
                                return;
                            }
                        });
                }

                function addAlertBox($class, $texte) {
                    $('.alert').alert('close');
                    let $alert = '<div class="alert-dismissible fade show alert ' + $class + '" role="alert">' + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + '</button><div class="messageAlert">' + $texte + '</div>' + '</div>';
                    $($alert).insertAfter($progress);
                }

                function fillProgressBar($percentCompleted) {
                    $(document).find('.progress-bar-upload')
                        .css('width', $percentCompleted + '%')
                        .attr('aria-valuenow', $percentCompleted)
                        .html($percentCompleted + '%');

                    if ($percentCompleted > 0) {
                        $progress.css('display', 'block');
                    } else {
                        $progress.css('display', 'none');
                    }
                }

                function getAllFileSize(form) {
                    const data = new FormData(form);
                    let size = 0;
                    for (let pair of data.entries()) {
                        if (pair[1] instanceof Blob) size += pair[1].size; else size += pair[1].length;
                    }
                    return size;
                }

                function calculateSize(img, maxWidth, maxHeight) {
                    let width = img.width;
                    let height = img.height;
                    if (width > height) {
                        if (width > maxWidth) {
                            height = Math.round((height * maxWidth) / width);
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width = Math.round((width * maxHeight) / height);
                            height = maxHeight;
                        }
                    }
                    return [width, height];
                }

                return myFilesUpload;
            });
        };
    }(jQuery));
